<div [@floatingMenu]="isVisible ? 'visible' : 'hidden'" class="container">
  <ul
    *ngIf="profileMenuItems$ | async as profileMenuItems"
    class="menu-items-list"
  >
    @for (
      profileMenuItem of profileMenuItems;
      track $index;
      let lastItem = $last
    ) {
      <li class="menu-item">
        <button
          mat-raised-button
          (click)="handleProfileNavigationItemAction(profileMenuItem)"
        >
          {{ profileMenuItem.name }}
        </button>
      </li>
      <div *ngIf="!lastItem" class="divider"></div>
    }
  </ul>
</div>
